import moment from 'moment'

export const genderLabel = {
  0: 'Other',
  1: 'Male',
  2: 'Female',
  3: 'Other',
}

// i18n keys mirroring genderLabel, translate at call sites with t(GENDER_LABEL_KEYS[gender])
export const GENDER_LABEL_KEYS = {
  0: 'common.gender.other',
  1: 'common.gender.male',
  2: 'common.gender.female',
  3: 'common.gender.other',
}

export const calculateAge = (birthdate) => {
  if (!birthdate) {
    return null
  }
  const parsed = moment(birthdate)
  // Guard against null/malformed birthdates — an Invalid Date would otherwise
  // silently return 0 and render as a misleading "Age 0".
  if (!parsed.isValid()) {
    return null
  }
  return moment.duration(moment().diff(parsed)).years()
}

export const isUserFromSameCommunity = (user, other) => {
  // Note: Admins and newly registered users do NOT have communities
  if (!user.communities?.length || !other.communities?.length) {
    return false
  }

  return user.communities[0].id === other.communities[0].id
}

export const isMemberOfCommunity = (user, communityId) =>
  !!user?.communities?.some((community) => Number(community.id) === Number(communityId))

// Anonymous visitors type their contact info; logged-in users need an email on the account (family admins/coaches)
export const canContactCommunity = (user, communityId) =>
  (!user || !!user.email) && !isMemberOfCommunity(user, communityId)

export const isUserFromSameFamily = (user, other) =>
  user.familyId !== undefined && other.familyId !== undefined ? user.familyId === other.familyId : user.family_id === other.family_id

export const isUserCoachInCommunity = (user, other) =>
  isUserFromSameCommunity(user, other) && user.type === 'Coach'

export const isAdminInFamily = (user, other) =>
  isUserFromSameFamily(user, other) && user.family_admin

export const hasUserWriteAccess = (user, other) => {
  const isCoachInCommunity = isUserCoachInCommunity(user, other)
  const isCurrentUser = user.id === other.id
  // TODO: Not sure why we have type === 'Student' here
  const isAdminInFamily_ = isAdminInFamily(user, other) && user.type === 'Student'

  return isCoachInCommunity || isCurrentUser || isAdminInFamily_
}
